import React from 'react';
import { BodyText, SpruceHelpInlineLink, Header3Text, SwitchDialogWindows } from 'ui-toolkit';
import { useSelector } from 'react-redux';
import { RootStore } from '../../../../../../store/types';

export interface IDeleteAchPushSwitchWindowProps {
  onAcknowledgeSuccess: () => void;
}

export const DeleteAchPushSwitchWindow: React.FC<IDeleteAchPushSwitchWindowProps> = ({ onAcknowledgeSuccess }) => {
  const {
    deleteAchPush: { fetchStatus: deleteAchPushStatus, fetchError: deleteAchPushFetchError },
  } = useSelector((store: RootStore) => store.order.escrow.disbursements);

  return (
    <SwitchDialogWindows
      errorMessage={
        <>
          <BodyText>{deleteAchPushFetchError?.message}</BodyText>
        </>
      }
      errorTitle={
        <Header3Text>
          ACH Push was not deleted. Please <SpruceHelpInlineLink /> to submit a request for help.
        </Header3Text>
      }
      isLoading={deleteAchPushStatus.fetching}
      isCompleted={deleteAchPushStatus.fetched}
      isError={deleteAchPushStatus.fetched && !deleteAchPushStatus.success}
      loadingTitle="Working..."
      onCloseClick={onAcknowledgeSuccess}
      successTitle="The ACH Push was deleted"
    />
  );
};
